import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../sdk/currentSession.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_instance177q6f44m9gy2 as Companion_instance } from './components/remittanceBreakdownGrid.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Never_getInstance3of1faxayn0qw as Never_getInstance } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Frame.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function RemittanceTestPage$render$slambda(this$0) {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_currentSessionNotNull();
    var tmp = (yield* await_0(this_0, $completion)).api_1.get_singleChildDay_52scz3_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = this$0.filter_1;
    var tmp$ret$1 = yield* await_1(this_1, $completion);
    var basis = yield* tmp.query_o986pg_k$(new (Query())(tmp$ret$1, VOID, VOID, 10000), $completion);
    return yield* Companion_instance.calculate_mx8h7j_k$(basis, $completion);
  }), 1);
}
function RemittanceTestPage$render$lambda$lambda($next) {
  return ($this$swap) => {
    $next.render$default_9uggcv_k$($this$swap);
    return Unit_instance;
  };
}
var RemittanceTestPageClass;
function RemittanceTestPage() {
  if (RemittanceTestPageClass === VOID) {
    class $ {
      constructor() {
        this.filter_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(Never_getInstance());
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        var data = rememberSuspending(VOID, VOID, VOID, RemittanceTestPage$render$slambda(this));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (Frame())(this_0.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_0.willAddChild_hz2iwc_k$(element);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = new (SwapView())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
        var this_1 = element_0;
        var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var alreadySwapping = {_v: false};
        reactive(this_1, 8, ($this$reactive) => {
          var c = $this$reactive.invoke_r7m7el_k$(data);
          queue.add_utx5q5_k$(c);
          var tmp;
          if (alreadySwapping._v) {
            return Unit_instance;
          }
          alreadySwapping._v = true;
          $l$loop: while (true) {
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!!queue.isEmpty_y1axqb_k$()) {
              break $l$loop;
            }
            var next = queue.removeAt_6niowx_k$(0);
            try {
              var tmp_0 = Companion_getInstance().Fade_1;
              this_1.swap_26x94b_k$(tmp_0, RemittanceTestPage$render$lambda$lambda(next));
            } catch ($p) {
              if ($p instanceof Exception()) {
                var e = $p;
                report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
              } else {
                throw $p;
              }
            }
          }
          alreadySwapping._v = false;
          return Unit_instance;
        });
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        element.onStartup_vrxh3i_k$();
        this_0.addChild_2qpft2_k$(element);
      }
    }
    protoOf($).get_title_iz32un_k$ = get_title;
    initMetadataForClass($, 'RemittanceTestPage', RemittanceTestPage, VOID, [Page()]);
    RemittanceTestPageClass = $;
  }
  return RemittanceTestPageClass;
}
//region block: exports
export {
  RemittanceTestPage as RemittanceTestPage1r728tkqg3lv5,
};
//endregion

//# sourceMappingURL=RemittanceTestScreen.mjs.map
